import type { ViewMode } from '../../lib/products';
import styles from './Toolbar.module.css';

interface ToolbarProps {
  search: string;
  onSearchChange: (value: string) => void;
  count: number;
  viewMode: ViewMode;
  onViewModeChange: (mode: ViewMode) => void;
}

export function Toolbar({
  search,
  onSearchChange,
  count,
  viewMode,
  onViewModeChange,
}: ToolbarProps) {
  return (
    <div className={styles.toolbar}>
      <div className={styles.searchWrap}>
        <svg
          className={styles.searchIcon}
          width="18"
          height="18"
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
          strokeWidth="2"
          strokeLinecap="round"
          aria-hidden="true"
        >
          <circle cx="11" cy="11" r="8" />
          <path d="M21 21l-4.35-4.35" />
        </svg>
        <input
          type={'text'}
          className={styles.search}
          placeholder={'Search products...'}
          value={search}
          onChange={(e) => onSearchChange(e.target.value)}
        />
      </div>

      <span className={styles.count}>{count} products</span>

      <div className={styles.viewToggle}>
        <button
          type={'button'}
          className={`${styles.viewBtn} ${viewMode === 'category' ? styles.viewBtnActive : ''}`}
          onClick={() => onViewModeChange('category')}
        >
          Category
        </button>
        <button
          type={'button'}
          className={`${styles.viewBtn} ${viewMode === 'individual' ? styles.viewBtnActive : ''}`}
          onClick={() => onViewModeChange('individual')}
        >
          Individual
        </button>
      </div>
    </div>
  );
}
